import {
  Container,
  Stack,
  Typography,
  Grid,
  Card,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Paper,
  Chip,
  IconButton,
  Tooltip
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from 'react-router-dom';
import { GetAll, apiURL, Put } from "../../../utils/apiCalls";
import { 
  Image, 
  FilterList, 
  Visibility,
  Category,
  PhotoLibrary
} from '@mui/icons-material';


const Posters = () => {
  const navigate = useNavigate();  
  const [category, setCategory] = useState([])
  const [slectcategory, setSelectcategory] = useState(0)
  const [posterdata,setPosterdata] = useState(1)


  const getcategory  = async () => {
    const response = await GetAll(apiURL + "/api/v1/posters/Allcategory");
    if (response && response.data && response.data.status) {
      response.data.data.push()
      setCategory(response.data.data);
      console.log(response.data.data);
    }
  };
  const getposter = async (e) => {
    
    const response = await GetAll(apiURL + `/api/v1/posters/category/${e}`);    
    if (response && response.data && response.data.status) {
      setPosterdata(response.data.data);
      console.log(response.data.data);
    }
  };
  useEffect(() => {
    getcategory();
   getposter(0)
  }, []);
  return (
    <Container sx={{ m: 0, width: "100%", maxWidth: "100%" }} maxWidth={false}>
      {/* Professional Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
            <Avatar sx={{ 
              bgcolor: '#1976d2', 
              width: 48, 
              height: 48,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              <PhotoLibrary sx={{ fontSize: 24, color: 'white' }} />
            </Avatar>
            <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Posters Gallery
            </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Browse and manage promotional posters and images
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      {/* Enhanced Filter Section */}
      <Fade in timeout={1000}>
        <Box sx={{ mb: 4 }}>
          <Paper elevation={2} sx={{ 
            p: 3, 
            borderRadius: 3,
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 40, 
                height: 40 
              }}>
                <FilterList sx={{ fontSize: 20 }} />
              </Avatar>
              <Typography variant="h6" fontWeight="600" color="text.primary">
                Filter by Category
              </Typography>
            </Stack>
            <Box sx={{ mt: 2 }}>
              <FormControl sx={{ width: '300px' }}>
                <InputLabel id="category">Select Category</InputLabel>
  <Select
    labelId="category"
    id="category"
                  label="Select Category"
              value={slectcategory}
              defaultValue={0}
              onChange={async (e) => {
                setSelectcategory(e.target.value)
              await getposter(e.target.value)
                  }}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: 2
                  }}
                >
                  <MenuItem value={0}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Category sx={{ fontSize: 16, color: '#1976d2' }} />
                      <Typography>All Categories</Typography>
                    </Stack>
                  </MenuItem>
                  {category?.map((data) => (
                    <MenuItem value={data.id} key={data.id}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Category sx={{ fontSize: 16, color: '#1976d2' }} />
                        <Typography>{data.name}</Typography>
                      </Stack>
                    </MenuItem>
                  ))}     
  </Select>
</FormControl>
            </Box>
          </Paper>
        </Box>
      </Fade>
      {/* Enhanced Poster Grid */}
      <Fade in timeout={1200}>
        <Box>
          <Grid container spacing={3}>
            {posterdata?.length > 0 ? (
              posterdata?.map((data, index) => (
                <Grid item xs={12} sm={6} md={4} key={data.id}>
                  <Zoom in timeout={1400 + (index * 100)}>
                    <Card 
                      elevation={4} 
                      onClick={() => {
                navigate(`/dashboard/imagepage/${data.id}`)
                      }}
                      sx={{ 
                        borderRadius: 3,
                        overflow: 'hidden',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'translateY(-8px)',
                          boxShadow: '0 16px 48px rgba(0,0,0,0.15)'
                        }
                      }}
                    >
                      {/* Poster Image */}
                      <Box sx={{ position: 'relative' }}>
                <CardMedia
                  component="img"
                    image={data.filepaths3}
                          alt={data.name || "Poster"}
                          sx={{ 
                            objectFit: "cover", 
                            height: 280,
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': {
                              transform: 'scale(1.05)'
                            }
                          }}
                        />
                        
                        {/* Overlay on Hover */}
                        <Box sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(25, 118, 210, 0.8)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: 0,
                          transition: 'opacity 0.3s ease-in-out',
                          '&:hover': {
                            opacity: 1
                          }
                        }}>
                          <Tooltip title="View Poster Details">
                            <IconButton 
                              sx={{ 
                                backgroundColor: 'white',
                                color: '#1976d2',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <Visibility sx={{ fontSize: 28 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>

                      {/* Poster Info */}
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Image sx={{ fontSize: 16, color: '#1976d2' }} />
                          <Typography variant="body2" color="text.secondary" fontWeight="500">
                            Poster #{data.id}
                          </Typography>
                        </Stack>
                        {data.name && (
                          <Typography variant="body1" fontWeight="600" sx={{ mt: 1 }}>
                            {data.name}
                          </Typography>
                        )}
                      </Box>
              </Card>
                  </Zoom>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Fade in timeout={1600}>
                  <Paper elevation={2} sx={{ 
                    p: 6, 
                    textAlign: 'center',
                    borderRadius: 3,
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef'
                  }}>
                    <Avatar sx={{ 
                      bgcolor: '#e0e0e0', 
                      width: 80, 
                      height: 80, 
                      mx: 'auto', 
                      mb: 3 
                    }}>
                      <PhotoLibrary sx={{ fontSize: 40, color: '#9e9e9e' }} />
                    </Avatar>
                    <Typography variant="h5" fontWeight="bold" color="text.secondary" gutterBottom>
                      No Posters Found
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      No posters are available in the selected category
                    </Typography>
                  </Paper>
                </Fade>
              </Grid>
            )}
          </Grid>
        </Box>
      </Fade>

      {/* Professional Stats Footer */}
      <Fade in timeout={1800}>
        <Box sx={{ mt: 4 }}>
          <Paper elevation={2} sx={{ 
            p: 3, 
            borderRadius: 3,
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#1976d2', 
                    width: 40, 
                    height: 40 
                  }}>
                    <PhotoLibrary sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {posterdata?.length || 0}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Posters
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#28a745', 
                    width: 40, 
                    height: 40 
                  }}>
                    <Category sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {category?.length || 0}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Categories
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ 
                    bgcolor: '#ffc107', 
                    width: 40, 
                    height: 40 
                  }}>
                    <Image sx={{ fontSize: 20 }} />
                  </Avatar>
                <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      Gallery
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      View Mode
                    </Typography>
                </Box>
              </Stack>
              </Grid>
        </Grid>
          </Paper>
      </Box>
      </Fade>
    </Container>
  );
};

export default Posters;
